import * as React from "react";
const SvgCompare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#091E42"
      d="M8.334 7.333h1.333V5.999h1.334V4.666H9.667V3.333H8.334v1.333H7.001v1.333h1.333zM7.001 9.999h4V8.666H7zm-1.667 2.667q-.55 0-.942-.392a1.28 1.28 0 0 1-.391-.941V1.999q0-.55.391-.941.391-.392.942-.392h4.667l4 4v6.667q0 .55-.392.941a1.28 1.28 0 0 1-.942.392zm0-1.333h7.333v-6L9.334 1.999h-4zm-2.667 4q-.55 0-.941-.392a1.28 1.28 0 0 1-.392-.942V4.666h1.333v9.333h7.334v1.334z"
    />
  </svg>
);
export default SvgCompare;
